import InsideProdigi from './InsideProdigi';

export default InsideProdigi;
